import { Component, HostListener, Input } from '@angular/core';

@Component({
  standalone: false,
  template: `
    <div class="row ps-3 pe-0 mb-1 jsonContainer" [style.max-width.px]="maxWidth">
      @if (data.length > 1) {
        @if (data[2]) {
          <div class="col-12 diff">
            <p [nbTooltip]="data[2]" nbTooltipStatus="default" nbTooltipPlacement="bottom">DIFF</p>
          </div>
        }
        <div class="col-6">
          <p class="title">OLD Data</p>
          <ngx-json-viewer [json]="data[0]"></ngx-json-viewer>
        </div>
        <div class="col-6">
          <p class="title">NEW Data</p>
          <ngx-json-viewer [json]="data[1]"></ngx-json-viewer>
        </div>
      } @else {
        <div class="col-12">
          <p class="title">Data</p>
          <ngx-json-viewer [json]="data[0]"></ngx-json-viewer>
        </div>
      }
    </div>
    `,
  styleUrls: ['./json-viewer.component.scss'],
})
export class JsonViewerComponent {
  @Input()
  data: any;
  maxWidth: number;
  leftSidebarOffset: number = 310;

  constructor() {
    this.maxWidth = window.innerWidth - this.leftSidebarOffset;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.maxWidth = window.innerWidth - this.leftSidebarOffset;
  }
}
